export default "__VITE_ASSET__d8972e87__"